import { useState } from 'react';
import { config } from '../config';
import { isSupportedLanguage, LanguageCode } from '../i18n/languages';
export const LOCAL_STORAGE_LANGUAGE_KEY = 'language';

const useAppLanguage = (): [LanguageCode, (languageCode: LanguageCode) => void] => {
  const storedLanguage = localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY);
  const initialLanguage = storedLanguage && isSupportedLanguage(storedLanguage)
    ? (storedLanguage as LanguageCode)
    : config.fallbackLanguage;
  const [appLanguage, setAppLanguage] = useState<LanguageCode>(initialLanguage);

  const setLanguage = (languageCode: LanguageCode) => {
    localStorage.setItem(LOCAL_STORAGE_LANGUAGE_KEY, languageCode);
    setAppLanguage(languageCode);
  }

  return [appLanguage, setLanguage];
}

export default useAppLanguage;
